import { downloadCall } from "./base";
import * as download from "@/util/download";

export async function callExportAuditLogins(data: {
  limit: number;
  uid: string;
  from: string;
  to: string;
}): Promise<void> {
  const blob = await downloadCall("export/auditLogins", true, data);
  download.exportBlob(`audit_logins_${data.uid}.csv`, blob);
}

export async function callExportTransactions(data: {
  limit: number;
  from: string;
  companyID: string;
  to: string;
}): Promise<void> {
  const blob = await downloadCall("export/transactions", true, data);
  download.exportBlob(`transactions_${data.companyID}.csv`, blob);
}

export async function callExportVending(tcod: string): Promise<void> {
  const blob = await downloadCall("export/vending?tcod=" + tcod, true, {});
  download.exportBlob(`topay_messages_${tcod}.csv`, blob);
}
